/** @jsx jsx */
import {Component} from 'react'
import PropTypes from 'prop-types'

import {jsx} from '@instructure/emotion'
import {withStyleOverrides} from '@instructure/quiz-common/util/withStyleOverrides'
import generateStyle from './styles'
import generateComponentTheme from './theme'

class PageContentUnstyled extends Component {
  static displayName = 'PageContent'
  static componentId = 'QuizzesPageContent'

  static propTypes = {
    children: PropTypes.node.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    styles: PropTypes.object,
  }

  render() {
    return (
      // this component is focusable for SkipToContent
      <div
        className="pageContent"
        tabIndex="-1"
        css={this.props.styles.content}
        aria-label={this.props.ariaLabel}
        role="region"
      >
        {this.props.children}
      </div>
    )
  }
}

const PageContent = withStyleOverrides(generateStyle, generateComponentTheme)(PageContentUnstyled)

export default PageContent
